import { themr } from '@friendsofreactjs/react-css-themr';
import DetailsSubHeader from './DetailsSubHeader';

export default themr('SapiSubscriptionModuleDetailsSubHeader')(DetailsSubHeader);
